import BaseButton from "./BaseButton"
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined'
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined'

type TogglePlayProps = {
  isPlaying: boolean
  togglePlay: () => void
}
const TogglePlay: React.FC<TogglePlayProps> = ({ isPlaying, togglePlay }) => {
  return (
    <BaseButton onClick={togglePlay}>
      {isPlaying ? (
        <PauseOutlinedIcon style={{ fontSize: '30px' }} />
      ) : (
        <PlayArrowOutlinedIcon style={{ fontSize: '30px' }} />
      )}
    </BaseButton>
  )
}

export default TogglePlay